module.exports = __webpack_public_path__ + "static/media/floor6.2900fb41.png";